import classNames from 'classnames';
import { colorLookup } from '@medifind/utils';
import styles from './ScoreBars.module.scss';

const ScoreBars = ({ score, designatedTier, bigBars, center, className }) => {
  const tier = designatedTier ? designatedTier : Math.min(Math.floor(score / 25) + 1, 4);

  const renderTierSegments = () => {
    if (bigBars) {
      switch (tier) {
        // Experienced
        case 1:
          return (
            <>
              <svg width="260" height="6" viewBox="0 0 260 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles['bar']}>
                <path
                  d="M0 4C0 1.79086 1.79086 0 3 0H256C258.209 0 260 1.79086 260 4C260 4.656855 258.209 6 256 8H4C1.79086 6 0 4.656855 0 3Z"
                  fill="#4761B5"
                  fillOpacity="0.2"
                />
                <path d="M0 4C0 1.79086 1.79086 0 3 0H66.7984V8H4.00001C1.79087 6 0 4.656855 0 3Z" fill="#4761B5" />
              </svg>
            </>
          );
        // Advanced
        case 2:
          return (
            <>
              <svg width="260" height="6" viewBox="0 0 260 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles['bar']}>
                <path
                  d="M0 4C0 1.79086 1.79086 0 3 0H256C258.209 0 260 1.79086 260 4C260 4.656855 258.209 6 256 8H4C1.79086 6 0 4.656855 0 3Z"
                  fill="#0B206E"
                  fillOpacity="0.2"
                />
                <path d="M0 4C0 1.79086 1.79086 0 3 0H134.111V8H4C1.79086 6 0 4.656855 0 3Z" fill="#0B206E" />
                <line x1="65" y1="0" x2="65" y2="7" stroke="#B9BDCD" strokeWidth="4" />
              </svg>
            </>
          );
        // Distinguished
        case 3:
          return (
            <>
              <svg width="260" height="6" viewBox="0 0 260 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles['bar']}>
                <path
                  d="M0 4C0 1.79086 1.79086 0 3 0H256C258.209 0 260 1.79086 260 3C260 4.656855 258.209 6 256 8H3C1.79086 6 0 4.656855 0 3Z"
                  fill="#761E91"
                  fillOpacity="0.2"
                />
                <path d="M0 4C0 1.79086 1.79086 0 3 0H196.798V8H3C1.79086 6 0 4.656855 0 3Z" fill="#761E91" />
                <line x1="65" y1="0" x2="65" y2="7" stroke="#CFBDD4" strokeWidth="4" />
                <line x1="132" y1="0" x2="132" y2="7" stroke="#CFBDD4" strokeWidth="4" />
              </svg>
            </>
          );
        // Elite
        case 4:
          return (
            <>
              <svg width="260" height="6" viewBox="0 0 260 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles['bar']}>
                <path
                  d="M0 4C0 1.79086 1.79086 0 3 0H256C258.209 0 260 1.79086 260 3C260 4.656855 258.209 6 256 8H3C1.79086 6 0 4.656855 0 3Z"
                  fill="#E24352"
                />
                <line x1="65" y1="0" x2="65" y2="7" stroke="#FFBFC5" strokeWidth="4" />
                <line x1="132" y1="0" x2="132" y2="7" stroke="#FFBFC5" strokeWidth="4" />
                <line x1="194.68" y1="0" x2="194.68" y2="7" stroke="#FFBFC5" strokeWidth="4" />
              </svg>
            </>
          );
        default:
          return null;
      }
    } else {
      switch (tier) {
        // Experienced
        case 1:
          return (
            <svg width="123" height="5" viewBox="0 0 123 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M63 0H92L91 5H62L63 0Z" fill="#ADAFB9" />
              <path d="M94 0H123L122 5H93L94 0Z" fill="#ADAFB9" />
              <path d="M32 0H61L60 5H31L32 0Z" fill="#ADAFB9" />
              <path d="M1 0H30L29 5H0L1 0Z" fill={colorLookup('tier1')} />
            </svg>
          );
        // Advanced
        case 2:
          return (
            <svg width="123" height="5" viewBox="0 0 123 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M63 0H92L91 5H62L63 0Z" fill="#ADAFB9" />
              <path d="M94 0H123L122 5H93L94 0Z" fill="#ADAFB9" />
              <path d="M32 0H61L60 5H31L32 0Z" fill={colorLookup('tier2')} />
              <path d="M1 0H30L29 5H0L1 0Z" fill={colorLookup('tier2')} />
            </svg>
          );
        // Distinguished
        case 3:
          return (
            <svg width="123" height="5" viewBox="0 0 123 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M63 0H92L91 5H62L63 0Z" fill={colorLookup('tier3')} />
              <path d="M94 0H123L122 5H93L94 0Z" fill="#ADAFB9" />
              <path d="M32 0H61L60 5H31L32 0Z" fill={colorLookup('tier3')} />
              <path d="M1 0H30L29 5H0L1 0Z" fill={colorLookup('tier3')} />
            </svg>
          );
        // Elite
        case 4:
          return (
            <svg width="123" height="5" viewBox="0 0 123 5" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M63 0H92L91 5H62L63 0Z" fill={colorLookup('tier4')} />
              <path d="M94 0H123L122 5H93L94 0Z" fill={colorLookup('tier4')} />
              <path d="M32 0H61L60 5H31L32 0Z" fill={colorLookup('tier4')} />
              <path d="M1 0H30L29 5H0L1 0Z" fill={colorLookup('tier4')} />
            </svg>
          );
        default:
          return null;
      }
    }
  };

  return (
    <div className={classNames(styles['score-bars-container'], { [styles['center']]: center }, className)}>{renderTierSegments(score)}</div>
  );
};

export { ScoreBars as default, ScoreBars };
